import React, { useState } from "react";
import { usePastClasses } from "hooks/use-live-classes/use-past-classes";
import {
  ClassSession,
  SubscriptionType
} from "services/api/sessions/sessionService.types";
import { CardCarousel, ClassReportCard } from "..";
import { PastClassDetailModal } from "../past-class-detail-modal/past-classes-detail-modal";
import { PastClassesBlockLoader } from "./past-classes-block.loader";
import { IPastClassesBlockProps } from "./past-classes-block.types";
import { PauseSubscriptionModal } from "../pause-subscription-modal/pause-subscription-modal";
import { useBoolean } from "hooks/use-boolean/use-boolean";

import {
  PaidUserWeeklySchedule,
  PaidUserWeeklyScheduleButton
} from "../paid-user-landing/paid-user-mobile.styles";
import { Arrow } from "components/icons/arrow";

const PastClassesBlock: React.FC<IPastClassesBlockProps> = ({
  primaryUser,
  subscriptionStatus,
  routeToWeeklySchedulePage
}) => {
  const {
    isPastSessionsLoading,
    pastSessions,
    mediaBaseURL,
    currentTimeStamp
  } = usePastClasses(primaryUser);
  const [selectedSession, setSelectedSession] = useState<ClassSession | null>(
    null
  );
  const subscriptionType = subscriptionStatus?.subscriptionType;

  const [isPausedSubscriptionModalOpen, setIsPausedSubscriptionModalOpen] =
    useBoolean();

  const handleShowMoreDetails = (classSession: ClassSession) => {
    if (subscriptionStatus?.subscriptionType === SubscriptionType.PAUSED) {
      setIsPausedSubscriptionModalOpen.on();
    } else {
      setSelectedSession(classSession);
    }
  };

  const getWeekStart = (date: Date) => {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);
    const startOfWeek = new Date(date.getFullYear(), date.getMonth(), diff);
    return startOfWeek;
  };

  const getWeekEnd = (date: Date) => {
    const startOfWeek = getWeekStart(new Date(date));
    return new Date(startOfWeek.setDate(startOfWeek.getDate() + 6));
  };

  const currentWeekStart = getWeekStart(new Date());
  const currentWeekEnd = getWeekEnd(new Date());

  const currentWeek: ClassSession[] = [];
  const pastWeek: ClassSession[] = [];
  const weeksBefore: ClassSession[] = [];

  const fillsessions = (pastSessions: ClassSession[] | undefined) => {
    if (!pastSessions) return [];

    pastSessions.forEach((pastSession: ClassSession) => {
      const startDate = new Date(pastSession.startDate);
      const startDateTime = startDate.getTime();
      const currentWeekStartTime = currentWeekStart.getTime();
      const currentWeekEndTime = currentWeekEnd.getTime();

      if (
        startDateTime >= currentWeekStartTime &&
        startDateTime <= currentWeekEndTime
      ) {
        currentWeek.push(pastSession);
      } else if (
        startDateTime >=
          new Date(
            new Date(currentWeekStart).setDate(currentWeekStart.getDate() - 7)
          ).getTime() &&
        startDateTime < currentWeekStartTime
      ) {
        pastWeek.push(pastSession);
      } else {
        weeksBefore.push(pastSession);
      }
    });

    if (currentWeek.length > 0) return currentWeek;
    else if (pastWeek.length > 0) return pastWeek;
    else return weeksBefore;
  };

  const filteredSessions = fillsessions(pastSessions);
  return (
    <>
      {isPastSessionsLoading && <PastClassesBlockLoader />}
      {!isPastSessionsLoading &&
        pastSessions &&
        pastSessions.length > 0 &&
        mediaBaseURL &&
        currentTimeStamp && (
          <>
            <CardCarousel
              title="Kelas yang udah selesai"
              onScrollToPrevPage={() => null}
              onScrollToNextPage={() => null}
            >
              {filteredSessions.map((classSession) => (
                <ClassReportCard
                  key={classSession.id}
                  classSession={classSession}
                  handleShowMoreDetails={() =>
                    handleShowMoreDetails(classSession)
                  }
                  isWidthApplied={true}
                />
              ))}
            </CardCarousel>
            <PaidUserWeeklySchedule>
              <PaidUserWeeklyScheduleButton
                onClick={() => routeToWeeklySchedulePage()}
                variant={"secondary"}
              >
                Cek video dan PDF materi kelas lainnya <Arrow />
              </PaidUserWeeklyScheduleButton>
            </PaidUserWeeklySchedule>
          </>
        )}
      {selectedSession &&
        mediaBaseURL &&
        currentTimeStamp &&
        subscriptionStatus && (
          <PastClassDetailModal
            classSession={selectedSession}
            baseMediaURL={mediaBaseURL}
            handleClose={() => {
              setSelectedSession(null);
            }}
            subscriptionType={subscriptionType}
            subscriptionStatus={subscriptionStatus}
            primaryUser={primaryUser}
          />
        )}

      {isPausedSubscriptionModalOpen && (
        <PauseSubscriptionModal
          isOpen={isPausedSubscriptionModalOpen}
          onClose={() => setIsPausedSubscriptionModalOpen.off()}
        />
      )}
    </>
  );
};

export { PastClassesBlock };
